export const STUDENT_FEEDBACK_LIMIT = 480
export const INSTRUCTIONS_LIMIT = 25000
export const ASSIGNMENT_NAME_LIMIT = 100
export const VERSION_NAME_LIMIT = 50
export const COMPONENT_NAME_LIMIT = 50
export const PATTERN_NAME_LIMIT = 100
export const TEST_NAME_LIMIT = 50
export const DISCIPLINE_NAME_LIMIT = 100
export const CONCEPTUAL_LABEL_NAME_LIMIT = 100
export const PROBLEM_SET_NAME_LIMIT = 100
export const GROUP_NAME_LIMIT = 50
export const QUESTION_NAME_LIMIT = 100
export const CATEGORY_NAME_LIMIT = 250
